<div class="categorias-container">
    <button class="nav-button prev" (click)="scrollLeft()" *ngIf="showNavButtons">
        <mat-icon>chevron_left</mat-icon>
    </button>
    
    <div class="categorias" id="categoriasContainer">
        <div class="categoria" *ngFor="let categoria of data; let i = index" 
            [attr.id]="i === 2 ? 'fourthCategory' : null"  
            [class.selected]="categoria === selectedCategory"
            (click)="onSelectCategory(categoria)">
            {{categoria}}
        </div>
    </div>

    <button class="nav-button next" (click)="scrollRight()" *ngIf="showNavButtons">
        <mat-icon>chevron_right</mat-icon>
    </button>
</div>